<div class="container-fluid" *cmLet="(filters$ | async) as filters">
    <div class="card">
        <cm-page-header class="header" [text]="title" [hideBackUrl]="true"></cm-page-header>
        <div class="filters-row">
            <cm-search-input minSearchLength="1" (valueChange)="onSearchChange($event)"></cm-search-input>
            <cm-page-actions [actions]="availableActions" (action)="onPageAction($event)"></cm-page-actions>
        </div>
        <cm-smart-table
            class="table"
            [headers]="tableHeaders"
            [rows]="tableData.rows"
            [order]="filters.order"
            (onRowClick)="onRowClick($event)"
            (orderChange)="onOrderChange($event)"
        >
        </cm-smart-table>
        <cm-card-footer-pagination
            class="card-footer"
            [collectionSize]="tableData.count"
            [page]="(filters$ | async).page"
            (pageChange)="onPageChange($event)"
        >
        </cm-card-footer-pagination>
    </div>
</div>
